import React from 'react';
import "./style.css"
import Uploading from './components/uploading';
import patients from '../../../../services/patients';
import users from '../../../../services/users/index';
import doctors from '../../../../services/doctors/index';
import { addDays, startOfDay, setMinutes } from 'date-fns';
import appointments from '../../../../services/appointments';
import movements from '../../../../services/movements/index';
import Table from './components/table/index';
var json = require('comment-json');

export default class AddJson extends React.Component {
    state = {
        isActive: false,
        uploading: false,
        progress: 0,
        users: []
    }

    inputRef = null;

    componentWillMount() {
        users.find({}, (err, users) => {
            this.setState({users: users})
        })
    }

    openModal = () => this.setState({isActive: true})
    closeModal = () => this.setState({isActive: false})

    openFilePicker = () => this.inputRef.click();

    insertPatients = (patientsArray, object) => {
        let transformed = []

        patientsArray.forEach((patient) => {
            transformed.push({
                _id: patient.id,
                name: patient.name,
                lastname: `${patient.lastname} ${patient.lastname2}`,
                phone: patient.phone
            })
        })

        patients.insert(transformed, (err, patients) => {
            this.insertUsers(object[6].data, patients, object);
        })
    }

    getRandomArbitrary = (min, max) => {
        return Math.ceil(Math.random() * (max - min) + min);
    }

    insertUsers = (usersArray, patients, object) => {
        let transformed = []

        usersArray.forEach((user) => {
            let newPassword = this.getRandomArbitrary(100000, 999999);
            let newPin = this.getRandomArbitrary(1000, 9999);
            transformed.push({
                _id: user.id,
                userName: user.username,
                password: newPassword.toString(),
                pin: newPin.toString(),
                role: user.role,
                status: "activo"
            })
        })

        users.insert(transformed, (err, users) => {
            this.setState({users: this.state.users.concat(users)})
            this.insertDoctors(object[3].data, object)
        })
    }

    insertDoctors = (doctorsArray, object) => {
        let transformed = []

        doctorsArray.forEach((doctor) => {
            transformed.push({
                _id: doctor.id,
                name: doctor.name,
                lastname: `${doctor.lastname} ${doctor.lastname2}`,
                email: doctor.mail,
                phone: doctor.phone,
                status: "activo"
            })
        })

        doctors.insert(transformed, (err, doctors) => {
            this.insertAppointments(object[2].data, object)
        })
    }

    getRightDate = (time) => {
        if(!time) {
            return {hours: "12", minutes: "00"}
        }
        let completeTime = time.split(":");
        let hours = Number(completeTime[0]), minutes = completeTime[1];
        if(hours < 8)
            hours += 12
        return {hours, minutes}
    }

    insertAppointments = (appointmentsArray, object) => {
        let transformed = []

        appointmentsArray.forEach((appointment) => {
            let date = startOfDay(addDays(new Date(appointment.date), 1));
            let {hours, minutes} = this.getRightDate(appointment.time);
            let time = `${hours}:${minutes}`;
            transformed.push({
                _id: appointment.id.toString(),
                time: time,
                date: date.getTime().toString(),
                old: true,

                patient: appointment.paciente_id.toString(),
                diagnostic: appointment.service,
                doctor: appointment.doctor_id.toString(),
                pay: 0,
                chair: appointment.chair.toString(),
                duration: (Number(appointment.length)/15) - 1,
                user: appointment.user_id.toString()
            })
        })

        appointments.insert(transformed, (err, appointments) => {
            this.insertMovements(object[5].data, object)
        })
    }

    insertMovements = (movementsArray) => {
        let transformed = []

        movementsArray.forEach((movement) => {
            let date = startOfDay(addDays(new Date(movement.created), 1));
            if(movement.cost > 0)
                transformed.push({
                    _id: movement.id,
                    pay: Number(movement.cost),
                    date: date.getTime(),
                    description: "",
                    user: movement.user_id.toString(),
                    patient: movement.paciente_id.toString()
                })
        })

        movements.insert(transformed, (err, movements) => {
            this.setState({uploading: false, isActive: false})
        })
    }

    onSelectFile = async (e) => {
        e.persist();
        await this.setState({uploading: true, isActive: true})
        const file = e.target.files[0]
        var success = (content) => {
            this.setState({uploading: false});
            let object = JSON.parse(content);
            this.insertPatients(object[4].data, object);
        }
        var fileReader = new FileReader();
        fileReader.onload = function ( evt ) { success( evt.target.result ) };
        fileReader.onprogress = (data) => {
            if (data.lengthComputable) {
                var progress = parseInt( ((data.loaded / data.total) * 100), 10 );
                this.setState({progress: progress});
            }
        }
        fileReader.readAsText(file);
    }

    render() {
        return (
            <div className="Developer">
                <div className="navbar">
                    <div className="navbar-brand">
                        <div className="navbar-item">
                            <h1>Opciones de desarrollador</h1>
                        </div>
                    </div>
                    <div className="navbar-menu is-active">
                        <div className="navbar-item">
                            <a onClick={this.openFilePicker}>Agregar respaldo de base de datos</a>
                        </div>
                    </div>
                    <input style={{display: "none"}} onChange={this.onSelectFile} type="file" ref={(ref) => this.inputRef = ref} />
                </div>
                <div className="page-content">
                    <div className="card">
                        <div className="card-content">
                            <Table users={this.state.users} />
                        </div>
                    </div>
                </div>
                <Uploading close={this.closeModal}
                    progress={this.state.progress}
                    uploading={this.state.uploading}
                    isActive={this.state.isActive}
                />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/scenes/main-page/scenes/add-json/index.js